import hookFns from "./hookFns";
import dataModel from "data-model";
import storageManager from "../utils/storageManager";

const fetchGridDataAsync = (fetchUrl, fetchType, fetchParams) => {
  return new Promise((resolve, reject) => {
    dataModel.fetchAsync(fetchUrl, fetchType ?? "GET", fetchParams).done((data) => resolve(data))
        .fail((error) => reject(error));
  })
}

export default function gridQuery(
  $grid = $(), // grid already wrapped in jquery
  {
    gridId = "",
    source = {},
    hideLoader = false,
    onRequestStart = () => {}, // void
    onRequestComplete = (response) => {}, // void
    forceRequest = (payload) => false, // boolean
    responseRecordsProp = "records",
    responseTotalRecordsProp = "totalRecords",
    cacheResults = true,
    cacheTTL = 1000 * 60 * 1 // 1 min
  } = {},
) {

  if(!source || !source._source) {
    throw new Error("Incompatible source. Provide the source returned from a $.jqx.dataAdapter().")
  }

  gridId = gridId || $grid.attr("id");
  const cacheKey = `gridQueryCache_${gridId}_${window.location.pathname}`
  let cache = {}
  let currentFetchRequest = "";
  let cacheLoaded = false;
  let refresh = false;

  const IsCacheValid = (key) => {
        const cachedData = cache[key];
        if (!cachedData) return false;

        const now = Date.now();
        const ttl = cacheTTL;
        return (now - cachedData.timestamp) < ttl;
  }

  const handleLoadServerData = async (serverdata, source, callback) => {
    try {
      
        // if(!cacheLoaded) {
        //     await loadCacheFromStorage()
        // }
       
        const requestStr = JSON.stringify(serverdata);
        const cacheItem = forceRequest != null && forceRequest(serverdata) ? null : cache[requestStr];

        if(onRequestStart) {
            onRequestStart();
        }

        if(!hideLoader) {
            $grid.jqxGrid("showloadelement")
        }
        
        // if((cacheItem && IsCacheValid(requestStr) && !refresh) || (requestStr === currentFetchRequest)) {
        //     const payload = {records: cacheItem?.records ?? [], totalrecords: cacheItem?.totalrecords ?? cacheItem?.records.length ?? 0}
        //     if(onRequestComplete) {
        //         onRequestComplete({...payload, isSuccess: true})
        //     }

        //     callback(payload);

        //     return
        // }

        currentFetchRequest = requestStr;
        const response = await fetchGridDataAsync(source.url, "GET", serverdata);

        const cbResponse = invokeSourceCallBacks(source, response);

        const records = cbResponse[responseRecordsProp] ?? [];
        const totalrecords = cbResponse[responseTotalRecordsProp] ?? records.length;

        if(records.length && cacheResults) {
            cache[requestStr] = {
                records: records,
                totalrecords: totalrecords,
                timestamp: Date.now()
            }

            //await storageManager.set(cacheKey, cache, true);
        }

        if(onRequestComplete) {
            onRequestComplete({records, totalrecords, isSuccess: true})
        }

        callback({ records, totalrecords });
    }
    catch(err) {
        console.error(err)
        if(onRequestComplete) {
            onRequestComplete({records: [], totalrecords: 0, isSuccess: false, error: err})
        }
    }
    finally {
        setTimeout(() => {
            $grid.jqxGrid("hideloadelement")
            currentFetchRequest = ""
            refresh = false;
        }, 300)
    }
  }

  const invokeSourceCallBacks = (source, response) => {
    if(source.beforeprocessing) {
        const r1 = source.beforeprocessing(response);
        response = r1 ?? response;
    }

    return response
  }

  const clearCache = async () => {
    await storageManager.remove(cacheKey);
    cache = {}
  }

  const loadCacheFromStorage = async () => {
    cache = await storageManager.get(cacheKey) ?? {}
    cacheLoaded = true
  }

  document.addEventListener('OnGridRefresh', async (event) => {
    const details = event.detail ?? {}

    if(details.gridId === $grid.attr("id")) {
        refresh = true
        await clearCache();
    }
  })

  return (options = {}, hooks = []) => {
    if(!options.source) {
        options.source = source;
    }

    options.source._options.loadServerData = handleLoadServerData;
    
    hookFns($grid, options)(hooks);
    
    return {
      $grid,
      options,
    };
  };
}
